export default function ParallaxSection() {
  return (
    <section
      className="relative w-full flex items-center justify-center"
      style={{
        height: '280px',
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=girls%20bar%20interior%20Japan%2C%20light%20blue%20powder%20blue%20color%20scheme%2C%20elegant%20bar%20counter%2C%20soft%20blue%20ambient%20lighting%2C%20white%20and%20light%20blue%20decor%2C%20feminine%20cozy%20atmosphere%2C%20modern%20Japanese%20bar%20design%2C%20wide%20angle%20interior%20view%2C%20high%20quality%20photography&width=1920&height=600&seq=para_a1&orientation=landscape)',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      }}
    >
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.45)' }} />
      <div className="relative z-10 text-center px-4">
        <h2
          className="text-white text-2xl md:text-4xl font-light tracking-widest"
          style={{
            fontFamily: "'Noto Serif JP', serif",
            textShadow: '0 2px 16px rgba(0,0,0,0.6)',
            letterSpacing: '0.2em',
          }}
        >
          癒しと笑顔に包まれて
        </h2>
      </div>
    </section>
  );
}
